import React, { FC } from "react";

import { IconButton } from "../../../IconButton";

export interface IExpandCellProps {
  isExpanded: boolean;
  expandRow: () => void;
  expandIcon: string;
  collapseIcon: string;
}

export const ExpandCell: FC<IExpandCellProps> = ({ isExpanded, expandRow, expandIcon, collapseIcon }) => {
  return (
    <div className="data-table__expand-cell">
      <IconButton testName="expand" icon={isExpanded ? collapseIcon : expandIcon} size="md" onClick={expandRow} />
    </div>
  );
};
